import React, { useState } from 'react';
import api from '../../lib/axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { Archive, Loader2 } from 'lucide-react';

export const ArchiveInactiveDialog = ({ onArchived }) => {
  const [open, setOpen] = useState(false);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [running, setRunning] = useState(false);

  const openDialog = async () => {
    setOpen(true);
    setLoading(true);
    try {
      const r = await api.post('/guardians/archive-inactive', { dry_run: true });
      setPreview(r.data.would_archive);
    } finally { setLoading(false); }
  };

  const run = async () => {
    setRunning(true);
    try {
      const r = await api.post('/guardians/archive-inactive', { dry_run: false });
      toast.success(`${r.data.archived} Zahler archiviert`);
      setOpen(false);
      onArchived?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Archivierung fehlgeschlagen');
    } finally { setRunning(false); }
  };

  return (
    <>
      <Button variant="outline" onClick={openDialog} data-testid="archive-inactive-btn">
        <Archive className="h-4 w-4 mr-2" /> Altbestand archivieren
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Altbestand archivieren</DialogTitle>
            <DialogDescription>
              Zahlungspflichtige ohne einzige aktive Belegung werden als inaktiv markiert.
              Sie verschwinden aus Listen und Statistiken, bleiben aber vollständig erhalten
              und können über „Archiv anzeigen" jederzeit eingesehen und reaktiviert werden.
            </DialogDescription>
          </DialogHeader>
          {loading ? (
            <div className="py-6 text-center"><Loader2 className="h-5 w-5 animate-spin inline text-slate-400" /></div>
          ) : (
            <div className="py-2 text-sm text-slate-700" data-testid="archive-preview">
              Betroffen: <span className="font-bold">{preview}</span> Zahlungspflichtige ohne aktive Belegung
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Abbrechen</Button>
            <Button onClick={run} disabled={loading || running || !preview} data-testid="archive-confirm-btn">
              {running ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <Archive className="h-4 w-4 mr-1" />}
              {preview ? `${preview} archivieren` : 'Archivieren'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
